// Vendor imports
const classNames = require('classnames')
const PropTypes = require('prop-types')
const React = require('react')
// Client V1 imports
const airbrake = require('client/lib/airbrake')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')

// Maintain markup consistency with the wiggin app-header component
const bem = BemEntity('SearchForm')

class SearchForm extends React.PureComponent {
  constructor(props) {
    super(props)
    // Create a ref to manage blur/focus state on the search input
    this.inputRef = React.createRef()
    // Setup initial state
    this.state = {
      supersearchResults: [],
      value: this.props.initialValue || ''
    }
    // Bind event listeners to the component context
    this.onSubmit = this.onSubmit.bind(this)
    this.onReset = this.onReset.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
  }

  componentDidMount() {
    this.fetchSupersearch()
  }

  componentDidUpdate() {
    this.setupSupercomplete()
  }

  componentWillUnmount() {
    this.teardownSupercomplete()
  }

  blur() {
    this.inputRef.current.blur()
  }

  focus() {
    this.inputRef.current.focus()
  }

  fetchSupersearch() {
    if (typeof window === 'object') {
      this.onSupersearchResults = supersearchResults => {
        this.setState({ supersearchResults }, () => {
          this.setupSupercomplete()
        })
      }
      require('client/models/user').API.supersearch()
      .then(results => {
        // No-op if the component has been un-mounted
        if (this.onSupersearchResults) {
          this.onSupersearchResults(results)
        }
      })
      .catch(err => airbrake.notify(err))
    }
  }

  setupSupercomplete() {
    if (typeof window === 'object') {
      const SuperAutocomplete = require('client/lib/super-autocomplete')
      const options = {
        // Values
        supersearchResults: this.state.supersearchResults,
        // Callbacks
        onNavigate: this.props.onNavigate,
        onSearch: this.props.onSubmit
      }
      if (!this.superAutocomplete) {
        const el = this.inputRef.current
        this.superAutocomplete = new SuperAutocomplete(el, options)
      } else {
        this.superAutocomplete.update(options)
      }
    }
  }

  teardownSupercomplete() {
    if (this.superAutocomplete) {
      this.superAutocomplete.destroy()
      delete this.superAutocomplete
    }
    delete this.onSupersearchResults
  }

  onInputChange() {
    this.setState({
      value: this.inputRef.current.value
    })
  }

  onSubmit(event) {
    event.preventDefault()
    if (this.state.value) {
      this.blur()
      this.props.onSubmit(this.state.value)
    } else {
      this.focus()
    }
  }

  onReset(event) {
    event.preventDefault()
    this.setState({ value: '' })
    this.props.onReset()
  }

  render() {
    return (
      tag('form', {
        className: classNames(
          this.props.className,
          bem.block()
        ),
        onReset: this.onReset,
        onSubmit: this.onSubmit
      },
        tag('button', {
          className: bem.element('button', 'submit'),
          type: 'submit'
        },
          tag('span', { className: 'mdi-action-search' })
        ),
        tag('input', {
          autoComplete: 'off',
          className: bem.element('input'),
          onChange: this.onInputChange,
          placeholder: 'Find people, collections and pages',
          ref: this.inputRef,
          type: 'text',
          value: this.state.value
        }),
        tag('button', {
          className: bem.element('button', 'reset'),
          type: 'reset'
        },
          tag('span', { className: 'mdi-navigation-close' })
        )
      )
    )
  }
}

SearchForm.propTypes = {
  // Values
  className: PropTypes.string,
  initialValue: PropTypes.string,
  // Callbacks
  onNavigate: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
}

module.exports = SearchForm
